var _style, _g, _g2, _defs, _line;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgDnaIntolerances(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 212.6 212.6",
    style: {
      enableBackground: "new 0 0 212.6 212.6"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\n\t.st0{fill:#F3A28A;}\n\t.st1{fill:#F4DBCC;}\n\t.st2{fill:#DEA993;}\n\t.st3{clip-path:url(#SVGID_2_);fill:none;stroke:#FDFFFF;stroke-width:6.0201;stroke-miterlimit:10;}\n")), _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M105.2,182.5c42.7,0,77.3-34.3,77.3-76.6s-34.6-76.6-77.3-76.6s-77.3,34.3-77.3,76.6 C27.9,148.2,62.5,182.5,105.2,182.5"
  })))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M118.8,67.4c-4.6-4-9.6-6.3-14.3-6.1c-15.4,0.5-32.1,27.4-31.2,53.2c0.1,2.7,0.4,5.2,0.8,7.7 c3.6,21,18.6,32.9,33.4,32.4c16.5-0.5,32.4-16.4,31.6-42.1C138.4,94.3,129.4,76.4,118.8,67.4"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M118.8,67.4c8.3,9.4,14.7,24.2,15.3,39.2c0.8,24.7-14.3,40-29.8,40.4c-12.5,0.4-25.2-8.6-30.2-25 c3.6,21,18.6,32.9,33.4,32.4c16.5-0.5,32.4-16.4,31.6-42.1C138.4,94.3,129.4,76.4,118.8,67.4"
  })), /*#__PURE__*/React.createElement("circle", {
    className: "st2",
    cx: 111.4,
    cy: 80.6,
    r: 2.4
  }), /*#__PURE__*/React.createElement("circle", {
    className: "st2",
    cx: 107.5,
    cy: 68.6,
    r: 1.5
  }), /*#__PURE__*/React.createElement("circle", {
    className: "st2",
    cx: 118.8,
    cy: 83.5,
    r: 1.3
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("path", {
    id: "SVGID_1_",
    d: "M104.9,182.5c42.8,0,77.6-34.4,77.6-76.9c0-42.4-34.7-76.9-77.6-76.9s-77.6,34.4-77.6,76.9 C27.3,148,62.1,182.5,104.9,182.5"
  }))), /*#__PURE__*/React.createElement("clipPath", {
    id: "SVGID_2_"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#SVGID_1_",
    style: {
      overflow: "visible"
    }
  })), _line || (_line = /*#__PURE__*/React.createElement("line", {
    className: "st3",
    x1: 41.4,
    y1: 42.3,
    x2: 175.2,
    y2: 163.5
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDnaIntolerances);
export default __webpack_public_path__ + "static/media/DNA_Intolerances.e089e211157d84dbc937f5d33ad4dbf7.svg";
export { ForwardRef as ReactComponent };